import { isMobile } from '@/utils';
import { getCommodityItemLabel } from './productLabel.config';

/**
 * @description 是否拥有哆啦A梦套餐
 * @param {string} countryCode
 * @param {array} commodities
 * @returns
 */
export const hasDoraemon = (countryCode = '', commodities = []) => {
  // 有套餐列表直接根据套餐列表判断是否启用套餐
  if (Array.isArray(commodities) && commodities.length > 0) {
    const doraemonArea = ['CN', 'HK', 'TW'];
    const doraemonCid = 3683;
    return commodities.includes(doraemonCid) && doraemonArea.includes(countryCode);
  }

  const doraemonArea = [];
  /** 简中上线时间 2024/12/5 19:00:00 */
  const timeSC = '1733396400000';
  /** 繁中上线时间 2024/12/12 19:00:00 */
  const timeTC = '1734001200000';
  const now = new Date().getTime();
  if (now >= timeSC) doraemonArea.push('CN');
  if (now >= timeTC) doraemonArea.push('HK', 'TW');

  return doraemonArea.includes(countryCode);
};

/**
 * 产品规格版本、是否展示自定义套餐的【静态】选项配置，自定义套餐在自定义套餐config中配置.
 * 是否展示父子级菜单等获取到产品信息后再动态判断
 * @param {string | string[]} versionTitle 规格/属性展示Title，没有写的话使用默认Title
 * @param {string} versionDesc 规格/属性展示下方描述，没有写的话不展示
 * @param {string} versionCommodityListTitle 套餐列表展示Title，没有写的话使用默认Title
 * @param {boolean} groupType 只有属性需要特别配置为attribute，其他初始化时默认识别  eg: normal(默认)  | specification(规格) | attribute(属性)
 * @param {number} colorIndex 颜色属性列表在第几位(从1开始)，结合运用后台配置
 * @param {number[]} topAttrIndexList 需要移动在套餐前面的属性索引(从1开始)
 * @param {boolean}  isNeedChangeAttrList 是否需要改变套餐属性顺序
 * @param {object} groupStyle 规格/属性样式配置：
 * 1. 以内部名称为key值 用于匹配规格 / 属性的配置。eg:{'白色':{icon:'【html | imgUrl】'}}
 * 2. itemCountInRow 一行有几个规格item，默认2个。
 * 3. commodityitemCountInRow 一行几个套餐item，默认1个
 * 4. commodityDescBottom 套餐描述放在套餐列表下面，不在套餐下拉里面
 * 5. versionTitleTag 规格属性标题前面的一个tag标签
 * 6. noTriggerVersionScroll 点击version时不自动定位到顶部
 */
export const getVersionConfig = (pid, LANG, code, commodities) => {
  const config = {
    14: {
      versionTitle: LANG['product.page.go2_version_title'],
    },
    15: {
      versionTitle: LANG['product.page.rs_version_title'],
    },
    233: {
      versionTitle: LANG['product.page.one_r_dive_case_version_title'],
    },
    295: {
      versionTitle: LANG['product.page.360_fpv_drone_version_title'],
    },
    17: {
      versionTitle: LANG['product.page.rs_1_inch_360_version_title'],
    },
    353: {
      versionTitle: LANG['product.page.SMO_360_version_title'],
    },
    298: {
      versionTitle: LANG['product.page.SMO_4K_version_title'],
    },
    19: {
      versionTitle: LANG['product.page.x3_memorycard_title'],
      groupType: 'attribute',
    },
    21: {
      versionTitle: LANG['product.virtualTour.version_title'],
      versionDesc: LANG['product.virtualTour.version_desc'],
      groupType: 'attribute',
      groupStyle: {
        itemCountInRow: 1,
      },
      versionTitleTag: LANG['product.virtualTour.free_label'],
      noTriggerVersionScroll: true,
    },
    22: {
      versionTitle: LANG['product.fmg.color_title'],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '灰色': {
          icon: 'https://res.insta360.com/static/d31ffbfd42b20b27b6007c08a0116201/gray.png',
        },
      },
    },
    24: {
      versionTitle: [LANG['product.page.go3_color_title'], LANG['product.page.go3_version_title']],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    25: {
      versionTitle: LANG['product.page.ace_version_title'],
    },
    26: {
      versionTitle: LANG['product.page.x3_memorycard_title'],
      groupType: 'attribute',
    },
    27: {
      versionTitle: [
        // 拥有哆啦A梦套餐需要更换文案
        hasDoraemon(code, commodities)
          ? LANG['product.page.go3s_doraemon_version_title']
          : LANG['product.page.go3_color_title'],
        LANG['product.page.go3_version_title'],
      ],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
        '哆啦A梦限定款': {
          icon: 'https://res.insta360.com/static/388718790fe707a3c8023df81705c78e/blue.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
      // 需要移动在套餐前面的属性索引(从1开始)
      topAttrIndexList: [1, 2],
    },
    29: {
      versionTitle: [LANG['product.page.link2_version_title'], LANG['product.page.link2_color_title']],
      groupType: 'attribute',
      groupStyle: {
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 2,
      // 需要移动在套餐前面的属性索引(从1开始)
      topAttrIndexList: [1, 2],
      // 是否需要改变套餐属性顺序
      isNeedChangeAttrList: true,
    },
    30: {
      versionTitle: LANG['product.page.ace_pro_2_version_title'],
      versionCommodityListTitle: LANG['product.page.ace_pro_2_commodity_list_title'],
    },
    32: {
      versionTitle: LANG['product.page.fmg2pro_version_title'],
      groupType: 'attribute',
      groupStyle: {
        '灵动白': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '遐想灰': {
          icon: 'https://res.insta360.com/static/d31ffbfd42b20b27b6007c08a0116201/gray.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    475: {
      versionCommodityListTitle: LANG['productNew.capacity_version_commodity_title'],
      versionTitle: LANG['product.page.go3_color_title'],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    511: {
      versionCommodityListTitle: LANG['productNew.capacity_version_commodity_title'],
      versionTitle: LANG['product.page.go3_color_title'],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    647: {
      versionCommodityListTitle: LANG['productNew.capacity_version_commodity_title'],
      versionTitle: LANG['product.page.go3_color_title'],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    552: {
      versionCommodityListTitle: LANG['productNew.capacity_version_commodity_title'],
      versionTitle: LANG['product.page.go3_color_title'],
      groupType: 'attribute',
      groupStyle: {
        '白色': {
          icon: 'https://res.insta360.com/static/9e712d5ae32576ace3e2189976659e82/white.png',
        },
        '黑色': {
          icon: 'https://res.insta360.com/static/27f3a687431a53d213bfc5c6b211db02/black.png',
        },
      },
      // 颜色属性列表在第几位(从1开始)，结合运用后台配置
      colorIndex: 1,
    },
    478: {
      versionTitle: LANG['product.page.x3_suction_cup_version_title'],
    },
    136: {
      // 背杆配件套餐
      versionTitle: LANG['product.page.x3_suction_cup_version_title'],
    },
    592: {
      versionCommodityListTitle: LANG['product.page.Tshirt_version_title'],
      groupStyle: {
        commodityitemCountInRow: 4,
        commodityDescBottom: true,
      },
    },
    593: {
      versionCommodityListTitle: LANG['product.page.Tshirt_version_title'],
      groupStyle: {
        commodityitemCountInRow: 4,
        commodityDescBottom: true,
      },
    },
    594: {
      versionCommodityListTitle: LANG['product.page.Tshirt_version_title'],
      groupStyle: {
        commodityitemCountInRow: 4,
        commodityDescBottom: true,
      },
    },
  };

  return config[pid] ?? {};
};

// 因为规格属性由||名称 动态生成，无法动态确定一个规格属性相匹配的Logoimg / label
// 前后两个参数 为number:套餐，为array：规格
// 匹配规则：只要productCommodity中存在任意一个套餐属于settingCommodity，则判断匹配成功。
export const isSame = (settingCommodity = [], productCommodity = []) => {
  if (typeof productCommodity === 'object' && typeof settingCommodity === 'object') {
    if (productCommodity.some((d) => settingCommodity.includes(d))) {
      return true;
    }
    return false;
  } else if (typeof productCommodity === 'number') {
    return settingCommodity === productCommodity;
  }
  return false;
};

// 匹配规则：productCommodity中所有套餐属于settingCommodity（完全相等，数量也一致），则判断匹配成功。
// const isAllSame = (settingCommodity = [], productCommodity = []) => {
//   if (typeof productCommodity === 'object' && typeof settingCommodity === 'object') {
//     if (
//       productCommodity.length === settingCommodity.length &&
//       productCommodity.every((d) => settingCommodity.includes(d))
//     ) {
//       return true;
//     }
//     return false;
//   } else if (typeof productCommodity === 'number') {
//     return settingCommodity === productCommodity;
//   }
//   return false;
// };

/**
 * 获取规格版本的label
 * @param cids 如果传入的cids在当前配置的cids之中，反之亦然，则返回当前规格的label
 * @param LANG
 * @return {array} Array
 */
export const getVersionLabel = (cids, LANG) => {
  const LABEL = getCommodityItemLabel({ LANG });
  switch (true) {
    case isSame([1747, 2029, 2181, 1748], cids):
      return [LABEL.ActionEssentials];
    case isSame([1742, 1962, 2182, 1743, 1744, 2183, 1745, 2184, 1746], cids):
      return [LABEL.bestValue];
    case isSame([1550, 1106, 1001], cids):
      return [LABEL.ultimatedPair];
    case isSame([1514, 975, 1038, 1039, 1040, 1042, 1095, 1304], cids):
    case isSame([1231, 1240, 1241], cids):
      return [LABEL.popular];
    // go3黑色套餐id （下线
    // case isAllSame([2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806, 2807, 2808, 2809, 2810, 2811], cids):
    //   return [LABEL.noRedNewVersion];
    // case isSame([2855, 2856], cids): // go3单相机黑色版本 （下线
    //   return [LABEL.noRedNewVersion];
    case isSame([2392, 2400, 2394, 2396, 2395, 2397, 2398, 2393], cids):
      return [LABEL.GO3_32G];
    case isSame([2376, 2379, 2380, 2382, 2381, 2383, 2384, 2378], cids):
      return [LABEL.GO3_64G];
    case isSame([2385, 2399, 2387, 2389, 2388, 2390, 2391, 2386], cids):
      return [LABEL.GO3_128G];
    case isSame(
      [2641, 2688, 2689, 2690, 2691, 2692, 2693, 2694, 3619, 3620, 3621, 3622, 3623, 3624, 3625, 3626, 3883],
      cids
    ):
      return [LABEL.acePro];
    case isSame([2695, 2696, 2697, 2698, 2699, 2700, 2701, 2712], cids):
      return [LABEL.ace];
    case isSame([2888, 2610], cids):
      return [LABEL.noRedNewVersion];
    default:
      return [];
  }
};

/**
 * 获取套餐名，基本上直接返回套餐名，额外部分套餐 / 规格 因为有图标logo 需展示图片
 * @param {object | number} cids 套餐传number, version传array
 * @param {string} commodityName 没有匹配上就直接返回commodityName
 */
export const getVersionName = ({ cids, X_Language, commodityName, LANG }) => {
  // 显示在套餐选购选项
  const LOGO = {
    // one_rs 莱卡版本
    Leica: {
      zh_cn: 'https://res.insta360.com/static/dfa6e12ad7dfb26128c74fe145a3b31c/1-inch_sc.svg',
      zh_tw: 'https://res.insta360.com/static/303c47ea36f7dae18c30dd52dc123f7b/1-inch_tc.svg',
      ko_kr: 'https://res.insta360.com/static/aa19c09c7153bf49c21eaa8e384b348d/1-inch_kr.svg',
      ja_jp: 'https://res.insta360.com/static/00575f79e9ad696e34e23676f13c70c5/1-inch_jp.svg',
      en_us: 'https://res.insta360.com/static/30c36b57a957321078a2abae88fd8b1f/1-inch_en.svg',
    },
    // oners 一英寸莱卡版本
    one_rs_1_inch_Leica: {
      zh_cn: 'https://res.insta360.com/static/2c04956cef5e19de7930baac219b7bbd/LCUFKM0PL2ZKK%201.svg',
      zh_tw: 'https://res.insta360.com/static/d90c31e71429f44f22e13a22f827cd7c/TC%20(1)%201.svg',
      ko_kr: 'https://res.insta360.com/static/79f4c6d50ac7918081aa9a6610906831/LCUFJRQNSMMZG%201.svg',
      ja_jp: 'https://res.insta360.com/static/528aa41f64539a5d030fb875ff86a664/LCUFJG8QSZFRS%201.svg',
      en_us: 'https://res.insta360.com/static/606ace615073151bb663394a746da890/Frame_17%20(1)%201.svg',
    },
    // Ace Pro
    ace_pro: {
      en_us: 'https://res.insta360.com/static/132e60147fca1b2bb05764540f94394b/en_Ace%20Pro.svg',
      zh_cn: 'https://res.insta360.com/static/61d68e366736e37f846d89200ce68193/cn_Ace%20Pro.svg',
      en_us_mob: 'https://res.insta360.com/static/907fcc01aaeecf1a700a9a4f18294543/Mo_en_Ace%20Pro.svg',
      zh_cn_mob: 'https://res.insta360.com/static/f109a05291d19738d45458fce2767a95/MoSC_Ace%20Pro.svg',
    },
    // Ace
    ace: {
      en_us: 'https://res.insta360.com/static/69898253f7b5ac97e7687e9506810847/en_Ace.svg',
      zh_cn: 'https://res.insta360.com/static/1ca7a45e81beb71385e48a544d848b82/cn_Ace.svg',
      en_us_mob: 'https://res.insta360.com/static/73065abf45c7ddf8e107220482b6a462/Mo_en_Ace.svg',
      zh_cn_mob: 'https://res.insta360.com/static/f70d178f3b5711c03dda42455fc8b80b/Mo_cn_Ace.svg',
    },
  };

  const isMob = isMobile();

  // 套餐判断前后为number，版本前后为数组
  switch (true) {
    case isSame([1749, 1750], cids):
    case isSame(974, cids):
      return `<img alt='' src=${LOGO.Leica[X_Language] ?? LOGO.Leica['en_us']} style='height:100%' />`;
    case isSame([1918, 1919, 1921, 1920, 1923], cids):
      return `<img alt='' src=${
        LOGO.one_rs_1_inch_Leica[X_Language] ?? LOGO.one_rs_1_inch_Leica['en_us']
      } style='height:100%' />`;
    case isSame([2695, 2696, 2697, 2698, 2699, 2700, 2701, 2712], cids):
      return `<img alt='' src=${
        LOGO.ace[`${X_Language}${isMob ? '_mob' : ''}`] ?? LOGO.ace[`en_us${isMob ? '_mob' : ''}`]
      } style=height:${isMob ? '32px' : '100%'} />`;
    case isSame([2641, 2688, 2689, 2690, 2691, 2692, 2693, 2694], cids):
      return `<img alt='' src=${
        LOGO.ace_pro[`${X_Language}${isMob ? '_mob' : ''}`] ?? LOGO.ace_pro[`en_us${isMob ? '_mob' : ''}`]
      } style=height:${isMob ? '24px' : '100%'} />`;
    case isSame([2558, 2564, 2570, 2576, 2582, 2588], cids):
      // 行业房产套餐 无需权益 属性的展示样式
      return `<span style='font-weight:400;'>${
        LANG['product.virtualTour.softwareBenefits.no_benefits_version_desc'] ?? ''
      }</span>`;
    default:
      return commodityName;
  }
};

/**
 * 根据versionConfig-groupList中的cids匹配获取属性/规格下的描述
 * @param cid
 * @param LANG
 */
export const getVersionDesc = ({ pid, cid, LANG }) => {
  const versionDescConfig = {
    21: [
      {
        name: 'FLOORFY',
        cids: [2553, 2559, 2565, 2571, 2577, 2583, 3383],
        text: LANG['product.virtualTour.softwareBenefits.FLOORFY_version_desc'],
      },
      {
        name: 'Kuula',
        cids: [2554, 2560, 2566, 2572, 2578, 2584, 3385],
        text: LANG['product.virtualTour.softwareBenefits.Kuula_version_desc'],
      },
      {
        name: '3Dvista',
        cids: [2555, 2561, 2567, 2573, 2579, 2585, 3386],
        text: LANG['product.virtualTour.softwareBenefits.3Dvista_version_desc'],
      },
      {
        name: 'Cloudpano',
        cids: [2556, 2562, 2568, 2574, 2580, 2586],
        text: LANG['product.virtualTour.softwareBenefits.Cloudpano_version_desc'],
      },
      {
        name: 'GoThru',
        cids: [2557, 2563, 2569, 2575, 2581, 2587, 3387],
        text: LANG['product.virtualTour.softwareBenefits.GoThru_version_desc'],
      },
      {
        name: 'Realsee',
        cids: [2839, 2838, 2837, 2836, 3384],
        text: LANG['product.virtualTour.softwareBenefits.Realsee_version_desc'],
      },
      // {
      //   name: 'noBenefits',
      //   cids: [2558, 2564, 2570, 2576, 2582, 2588],
      //   text: LANG['product.virtualTour.softwareBenefits.no_benefits_version_desc'],
      // },
    ],
  };

  if (versionDescConfig[pid]) {
    return versionDescConfig[pid]?.find((d) => d.cids.includes(cid))?.text ?? '';
  }
  return '';
};

/**
 * 根据versionConfig-groupList中的cids匹配获取属性/规格下的intro信息
 * @param cid
 * @param LANG
 */
export const getVersionItemIntro = ({ pid, cid, LANG }) => {
  const versionItemIntroConfig = {
    21: [
      {
        name: 'FLOORFY',
        cids: [2553, 2559, 2565, 2571, 2577, 2583, 3383],
        text1: LANG['product.virtualTour.softwareBenefits.FLOORFY_details_text'],
        text2: LANG['product.virtualTour.softwareBenefits.FLOORFY_about_software_text'],
      },
      {
        name: 'Kuula',
        cids: [2554, 2560, 2566, 2572, 2578, 2584, 3385],
        text1: LANG['product.virtualTour.softwareBenefits.Kuula_details_text'],
        text2: LANG['product.virtualTour.softwareBenefits.Kuula_about_software_text'],
      },
      {
        name: '3Dvista',
        cids: [2555, 2561, 2567, 2573, 2579, 2585, 3386],
        text1: LANG['product.virtualTour.softwareBenefits.3Dvista_version_text'],
        text2: LANG['product.virtualTour.softwareBenefits.3Dvista_about_software_text'],
      },
      {
        name: 'Cloudpano',
        cids: [2556, 2562, 2568, 2574, 2580, 2586],
        text1: LANG['product.virtualTour.softwareBenefits.Cloudpano_details_text'],
        text2: LANG['product.virtualTour.softwareBenefits.Cloudpano_about_software_text'],
      },
      {
        name: 'GoThru',
        cids: [2557, 2563, 2569, 2575, 2581, 2587, 3387],
        text1: LANG['product.virtualTour.softwareBenefits.GoThru_details_text'],
        text2: LANG['product.virtualTour.softwareBenefits.GoThru_about_software_text'],
      },
      {
        name: 'Realsee',
        cids: [2839, 2838, 2837, 2836, 3384],
        text1: LANG['product.virtualTour.softwareBenefits.Realsee_details_text'],
        text2: LANG['product.virtualTour.softwareBenefits.Realsee_software_text'],
      },
    ],
  };

  // 海外房产套餐
  if (pid === 21) {
    const item = versionItemIntroConfig[pid]?.find((d) => d.cids.includes(cid));
    if (item) {
      return `<ul style="font-size: 14px;">
    <li><span style="color: #4B4D50;">
    <strong>${LANG['product.virtualTour.softwareBenefits.details']}: </strong>
    </span></li></ul>
    <p style="color: #4B4D50; white-space: break-spaces;padding-left: 12px;">${item.text1}</p>
    <ul style="margin-top: 8px;">
    <li><span style="color: #4B4D50;">
    <strong>${LANG['product.virtualTour.softwareBenefits.about_software']}: </strong>
    </span></li></ul><p style="color: #4B4D50; white-space: break-spaces;padding-left: 12px;">${item.text2}</p>`;
    }

    return '';
  }

  return '';
};

export default { getVersionName, getVersionLabel, getVersionConfig, isSame };
